var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineCake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 22.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h20c.41 0 .75.34.75.75s-.34.75-.75.75H2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.14 22v-9c0-1.24-1.16-2.25-2.58-2.25H6.44c-1.42 0-2.58 1.01-2.58 2.25v9c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-9c0-2.07 1.83-3.75 4.08-3.75h11.11c2.25 0 4.08 1.68 4.08 3.75v9a.74.74 0 0 1-.74.75c-.41 0-.75-.34-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.69 10V7.17c0-.78-.75-1.42-1.66-1.42H7.98c-.92 0-1.66.64-1.66 1.42V10c0 .41-.34.75-.75.75s-.76-.34-.76-.75V7.17c0-1.61 1.42-2.92 3.16-2.92h8.05c1.74 0 3.16 1.31 3.16 2.92V10a.74.74 0 0 1-.74.75c-.41 0-.75-.34-.75-.75zM15.23 15.65v-.31c0-.33-.27-.6-.6-.6-.33 0-.6.27-.6.6v.31a2.1 2.1 0 1 1-4.2 0v-.31c0-.33-.27-.6-.6-.6-.33 0-.6.27-.6.6v.31a2.1 2.1 0 1 1-4.2 0v-.33c0-.32-.26-.59-.59-.6h-.37a.755.755 0 0 1-.74-.76c.01-.41.34-.74.75-.74h.38c1.14.02 2.07.96 2.07 2.1v.33c0 .33.27.6.6.6.33 0 .6-.27.6-.6v-.31a2.1 2.1 0 1 1 4.2 0v.31c0 .33.27.6.6.6.33 0 .6-.27.6-.6v-.31a2.1 2.1 0 1 1 4.2 0v.31c0 .33.27.6.6.6.33 0 .6-.27.6-.6v-.31c0-1.16.94-2.1 2.1-2.1h.45c.41 0 .75.34.75.75s-.34.75-.75.75h-.45c-.33 0-.6.27-.6.6v.31a2.1 2.1 0 1 1-4.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 5V3c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM15.25 5V3c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM11.25 5V2c0-.41.34-.75.75-.75s.75.34.75.75v3c0 .41-.34.75-.75.75s-.75-.34-.75-.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineCake);
export default __webpack_public_path__ + "static/media/vuesax-outline-cake.e32e1a915bddbc5f4d304e786fd2b692.svg";
export { ForwardRef as ReactComponent };